import { NgModule, ErrorHandler } from "@angular/core"
import { BrowserModule } from "@angular/platform-browser"
import { IonicApp, IonicModule, IonicErrorHandler } from "ionic-angular"

import { App } from "./app.component"
import { EventService } from "../services/event"

import { Slim } from "../components/slim/slim.angular2"
import { EventCard } from "../components/event-card"
import { EventsList } from "../components/events-list"
import { TopBar } from "../components/top-bar"
import { UserPopover } from "../components/user-popover"

import { LoadingPage } from "../pages/loading"
import { LoginPage } from "../pages/login"
import { RegisterPage } from "../pages/register"
import { RegisterFinishPage } from "../pages/register/finish"
import { UseTermsPage } from "../pages/register/use-terms"
import { HomePage } from "../pages/home"
import { EventsPage } from "../pages/events"
import { EventDetailPage } from "../pages/events/detail"
import { EventReleasePage } from "../pages/events/release"
import { EventExchangePage } from "../pages/events/exchange"
import { EventsListPage } from "../pages/events/list"
import { EventPickListPage } from "../pages/events/pick-list"
import { SettingsPage } from "../pages/settings"
import { NotificationsSettingsPage } from "../pages/settings/notifications"
import { CalendarSettingsPage } from "../pages/settings/calendar"
import { ProfilePage } from "../pages/profile"
import { ProfilePicturePage } from "../pages/profile/picture"
import { ProfileDataPage } from "../pages/profile/data"
import { ProfilePasswordPage } from "../pages/profile/password"
import { ProfileEmailPage } from "../pages/profile/email"
import { UserPickListPage } from "../pages/users/pick-list"
import { HelpPage } from "../pages/help"
import { WelcomePage } from "../pages/welcome"
import { AppTabPages } from "../pages/tabs"

const appComponents = [
  Slim,
  App,
  EventCard,
  EventsList,
  TopBar,
  UserPopover,
  LoadingPage,
  LoginPage,
  RegisterPage,
  RegisterFinishPage,
  UseTermsPage,
  HomePage,
  EventsPage,
  EventDetailPage,
  EventReleasePage,
  EventExchangePage,
  EventsListPage,
  EventPickListPage,
  SettingsPage,
  NotificationsSettingsPage,
  CalendarSettingsPage,
  ProfilePage,
  ProfilePicturePage,
  ProfileDataPage,
  ProfilePasswordPage,
  ProfileEmailPage,
  UserPickListPage,
  HelpPage,
  WelcomePage,
  AppTabPages
]

@NgModule({
  declarations: appComponents,
  imports: [
    BrowserModule,
    IonicModule.forRoot(App)
  ],
  bootstrap: [IonicApp],
  entryComponents: appComponents,
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    EventService
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts